var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickactionssendMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10614_87852)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#D2D4D6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1664 11.2667L19.2414 8.90834C22.4164 7.85001 24.1414 9.58334 23.0914 12.7583L20.7331 19.8333C19.1497 24.5917 16.5497 24.5917 14.9664 19.8333C14.5257 18.5114 13.4884 17.474 12.1664 17.0333C7.40807 15.45 7.40807 12.8583 12.1664 11.2667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4248 17.375L17.4081 14.3833L14.4248 17.375Z",
    fill: "url(#paint0_linear_10614_87852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4248 17.375L17.4081 14.3833",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10614_87852",
    x1: 15.9001,
    y1: 14.5802,
    x2: 15.9001,
    y2: 16.1381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11C7EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#15E8E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#1FD3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23C2D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10614_87852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickactionssendMoney);
export default __webpack_public_path__ + "static/media/quickactions[send-money].05788bbe.svg";
export { ForwardRef as ReactComponent };